export default __webpack_public_path__ + "static/media/foreal_vs_louisville_texture.c466e880.jpg";